module.exports = __webpack_public_path__ + "img/cnpj.ab0b8f10.png";